'use client'

import Image from 'next/image'
import {createPortal} from 'react-dom'
import {useCallback} from 'react'
import {HeaderEvent} from '../../analytics/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import s from './style.module.scss'
import {LanguageCodes} from '@app/i18n/settings'
import {useTagsPageAnalytics} from '@app/[lang]/(common-header-footer)/tags/(tag-page)/[tagName]/[tagId]/get-tag-page-analytics/tag-page-analytics-context'
import useSearchStore from '@app/components/search-section/store/search-store'
import useWindowSize from '@app/hooks/use-window-size'

type Props = {
  searchSection: React.ReactNode
  lang: LanguageCodes
}

const SearchBtn = ({searchSection}: Props) => {
  const {tagAnalyticsData} = useTagsPageAnalytics()
  const {isFocused, setFocused} = useSearchStore()
  const {width} = useWindowSize()
  const handleClick = useCallback(() => {
    if (!isFocused) {
      setFocused(true)
    }
    triggerAnalytics(HeaderEvent.SearchButtonClicked, tagAnalyticsData).sendAll()
  }, [isFocused, tagAnalyticsData])

  const openPortal = isFocused && width < 1024

  return !openPortal ? (
    <button onClick={handleClick} className={s.search_btn}>
      <Image src='https://static.gamezop.com/comet/assets/img2/search.svg' alt='search button' width={20} height={20} />
    </button>
  ) : (
    createPortal(searchSection, document.body)
  )
}

export default SearchBtn
